import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenSeedlingCreateAction from './communityGardenSeedlingCreate.action.json' with { type: 'json' }
import { communityGardenSeedlingObject } from '../../communityGardenSeedlingObject'

const communityGardenSeedlingCreateDefinition = defineAction({
  ...communityGardenSeedlingCreateAction,

  input: communityGardenSeedlingObject
    .pick({
      id: true,
      communityGardenId: true,
      type: true,
      quantity: true,
      createdAt: true,
      updatedAt: true,
    })
    .extend({ id: communityGardenSeedlingObject.shape.id.nullish() }),
  output: z.object({ id: communityGardenSeedlingObject.shape.id }),
})

export default communityGardenSeedlingCreateDefinition
